import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import * as fcl from "@onflow/fcl";
import { shortenHex } from "shared/utils/address.js";
import { isUserPremium } from "shared/utils/user.js";

/*interface ButtonLoginProps {
  content: object;
  className?: string;
  flowUser?: object;
  assistantUser?: object;
  redirectToHq: boolean;
}*/

const ButtonLogin = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const logIn = () => {
    fcl.authenticate();
    if (props.redirectToHq) {
      navigate("/user/me");
    }
  };

  return (
    <Link
      className={
        props.className + (location.pathname.startsWith("/user/" + props.assistantUser?.address) ? " active" : "")
      }
      onClick={props.assistantUser ? undefined : logIn}
      to={props.assistantUser ? "/user/" + props.assistantUser.address : undefined}
    >
      <div className="px-1 py-md-2 px-md-0">
        {props.assistantUser ? (
          <div className="position-relative Menu-hq d-inline-block align-items-center text-center">
            <div className="position-relative text-center" style={{ zIndex: 2 }}>
              <i className="bi bi-person-circle lh-1 px-1"></i>
              <div className={"d-block w-100 lh-1"} style={{ fontSize: "12px" }}>
                My HQ
              </div>
            </div>

            {isUserPremium(props.assistantUser) && (
              <div
                className="premium-background px-1"
                style={{
                  zIndex: 1,
                  top: "-6px",
                  position: "absolute",
                  borderRadius: 2,
                  fontSize: "8px",
                  left: "50%",
                  height: "48px",
                  width: "48px",
                  transform: "translateX(-50%)",
                }}
              ></div>
            )}
          </div>
        ) : (
          props.content
        )}
      </div>
    </Link>
  );
};

export default ButtonLogin;
